(() => {
  if (window.bdsCollectWeekendInit) return;
  window.bdsCollectWeekendInit = true;

  const ATTR = 'Collect weekend';

  const isValid = (value) => typeof value === 'string' && value.trim().length > 0;

  const cartUpdateUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart/update.js`;
  };

  const currentValue = () => {
    const selected = [...document.querySelectorAll('[data-bds-collect-weekend]')]
      .map((el) => el.value)
      .find(isValid);
    return selected || '';
  };

  const applyGate = () => {
    const roots = document.querySelectorAll('[data-bds-weekend-root]');
    if (!roots.length) {
      document.documentElement.removeAttribute('data-bds-weekend-lock');
      return;
    }
    const ok = isValid(currentValue());
    roots.forEach((root) => {
      root.setAttribute('data-ready', ok ? 'true' : 'false');
    });
    document.documentElement.dataset.bdsWeekendLock = ok ? '0' : '1';
    document.querySelectorAll('#checkout, [name="checkout"]').forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement) && !(btn instanceof HTMLInputElement)) return;
      if (ok) btn.removeAttribute('disabled');
      else btn.setAttribute('disabled', 'disabled');
    });
  };

  const save = async (value) => {
    await fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR]: value } }),
    });
  };

  document.addEventListener('change', async (event) => {
    const select = event.target && event.target.closest && event.target.closest('[data-bds-collect-weekend]');
    if (!select) return;
    document.querySelectorAll('[data-bds-collect-weekend]').forEach((other) => {
      if (other !== select) other.value = select.value;
    });
    if (isValid(select.value)) {
      try {
        await save(select.value);
      } catch (err) {
        /* still gate locally so they can retry */
      }
    }
    applyGate();
  });

  document.addEventListener(
    'click',
    (event) => {
      const pay = event.target && event.target.closest && event.target.closest('#checkout, [name="checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
      if (!pay) return;
      if (!document.querySelector('[data-bds-weekend-root]')) return;
      if (isValid(currentValue())) return;
      event.preventDefault();
      event.stopPropagation();
      const first = document.querySelector('[data-bds-collect-weekend]');
      if (first) {
        first.setAttribute('aria-invalid', 'true');
        first.focus();
      }
    },
    true
  );

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.querySelector('[data-bds-collect-weekend]')) return;
    if (isValid(currentValue())) return;
    event.preventDefault();
    const first = form.querySelector('[data-bds-collect-weekend]');
    if (first) {
      first.setAttribute('aria-invalid', 'true');
      first.focus();
    }
  });

  const start = () => applyGate();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('cart:update', applyGate);
})();
